export const TicketStatesGlobal = {
  COMMENT_SAVED: 'digital.fino.cyclope.api.events.CommentSavedEvent',
  DEADLINE_LAPSED: 'digital.fino.cyclope.api.events.DeadlineLapsed',
  FAX_DOCUMENT_RECEIVED: 'digital.fino.cyclope.api.events.FaxDocumentReceived',
  REMINDER_SENT: 'digital.fino.cyclope.api.events.ReminderSent',
  REQUEST_STARTED: 'digital.fino.cyclope.api.events.AidRequestStarted',
  REQUEST_COMPLETED: 'digital.fino.cyclope.api.events.RequestCompleted',
  KWS_ORDER_COMPLETED: 'digital.fino.cyclope.api.domain.KwsOrderCompleted',
};

export const TicketStatesTransferring = {
  ACCEPT_OUTGOING_REQUEST:
    'digital.fino.cyclope.api.events.transferring.AcceptedOutgoingRequest',
  DIRECT_DEBITS_IMPORTED:
    'digital.fino.cyclope.api.events.transferring.DirectDebitsImported',
  FAX_DOCUMENT_RECEIVED: 'digital.fino.cyclope.api.events.FaxDocumentReceived',
  FINANCES_VERIFIED:
    'digital.fino.cyclope.api.events.transferring.FinancesVerified',
  RECEIVED_OUTGOING_REQUEST:
    'digital.fino.cyclope.api.events.transferring.ReceivedOutgoingRequest',
  RECEIVED_PAYMENTS_IMPORTED:
    'digital.fino.cyclope.api.events.transferring.ReceivedPaymentsImported',
  REJECTED_REQUEST:
    'digital.fino.cyclope.api.events.transferring.RejectedRequest',
  REJECTION_SENT: 'digital.fino.cyclope.api.events.transferring.RejectionSent',
  REJECTION_DOCUMENT_TRANSFERS_FAILED:
    'digital.fino.cyclope.api.events.transferring.RejectionDocumentTransferFailed',
  REQUEST_DATA_COMPLETED:
    'digital.fino.cyclope.api.events.transferring.RequestDataCompleted',
  STANDING_ORDERS_IMPORTED:
    'digital.fino.cyclope.api.events.transferring.StandingOrdersImported',
  SCHEDULED_TRANSACTIONS_IMPORTED:
    'digital.fino.cyclope.api.events.transferring.ScheduledTransactionsImported',
  TRANSACTION_DATA_ADDED:
    'digital.fino.cyclope.api.events.transferring.TransactionDataAdded',
  TRANSACTION_DATA_COMPLETE:
    'digital.fino.cyclope.api.events.transferring.TransactionDataComplete',
  TRANSACTION_DATA_SENT:
    'digital.fino.cyclope.api.events.transferring.TransactionDataSent',
  TRANSACTION_DATA_SENT_VIA_FAX:
    'digital.fino.cyclope.api.events.transferring.TransactionDataSentViaFax',
  TRANSACTION_DATA_SKIPPED:
    'digital.fino.cyclope.api.events.transferring.TransactionDataSkipped',
  TRANSACTION_DATA_TRANSFER_FAILED:
    'digital.fino.cyclope.api.events.transferring.TransactionDataTransferFailed',
};

export const TicketStatesReceiving = {
  ALL_DOCUMENTS_SENT:
    'digital.fino.cyclope.api.events.receiving.AllDocumentsSent',
  BALANCE_LIST_DATA_RECEIVED:
    'digital.fino.cyclope.api.events.receiving.BalanceListDataReceived',
  BALANCE_LIST_DOCUMENT_RECEIVED:
    'digital.fino.cyclope.api.events.receiving.BalanceListDocumentReceived',
  BALANCE_LIST_WITHDRAWN:
    'digital.fino.cyclope.api.events.BalanceListWithdrawn',
  CUSTOMER_PACKAGE_SENT:
    'digital.fino.cyclope.api.events.receiving.CustomerPackageSent',
  CUSTOMER_PACKAGE_RENDERED:
    'digital.fino.cyclope.api.events.receiving.CustomerPackageRendered',
  CUSTOMER_PACKAGE_TRANSFER_FAILED:
    'digital.fino.cyclope.api.events.receiving.CustomerPackageTransferFailed',
  CLOSED_BY_CUSTOMER:
    'digital.fino.cyclope.api.events.receiving.ClosedByCustomer',
  DOCUMENT_SENDING_STARTED:
    'digital.fino.cyclope.api.events.receiving.DocumentSendingStarted',
  DOCUMENT_SENT: 'digital.fino.cyclope.api.events.receiving.DocumentSent',
  DOCUMENT_SENT_VIA_FAX:
    'digital.fino.cyclope.api.events.receiving.DocumentSentViaFax',
  FAX_DOCUMENT_RECEIVED: 'digital.fino.cyclope.api.events.FaxDocumentReceived',
  FINANCES_COMPLETED_WITH_PAYMENT_PARTNERS:
    'digital.fino.cyclope.api.events.receiving.FinancesCompletedWithPaymentPartners',
  FINANCES_RECEIVED_FROM_OLD_BANK:
    'digital.fino.cyclope.api.events.receiving.FinancesReceivedFromOldbank',
  INITIALIZATION_CONFIRMED:
    'digital.fino.cyclope.api.events.receiving.InitializationConfirmed',
  INITIALIZATION_CONFIRMED_BY_USER:
    'digital.fino.cyclope.api.events.receiving.InitializationConfirmedByUser',
  OUTGOING_SIGNED_WARRANT_RENDERED:
    'digital.fino.cyclope.api.events.receiving.OutgoingSignedWarrantRendered',
  PAYMENT_PARTNER_ADDRESS_SAVED:
    'digital.fino.cyclope.api.events.receiving.PaymentPartnerAddressSaved',
  PAYMENT_PARTNER_NOTIFICATION_FAILED:
    'digital.fino.cyclope.api.events.receiving.PaymentPartnerNotificationFailed',
  PAYMENT_PARTNER_NOTIFICATION_RENDERED:
    'digital.fino.cyclope.api.events.receiving.PaymentPartnerNotificationRendered',
  PAYMENT_PARTNER_INFORMATION_ABORTED:
    'digital.fino.cyclope.api.events.receiving.PaymentPartnersInformationAborted',
  PAYMENT_PARTNER_INFORMATION_STARTED:
    'digital.fino.cyclope.api.events.receiving.PaymentPartnersInformationStarted',
  RECEIVED_REJECTION:
    'digital.fino.cyclope.api.events.receiving.ReceivedRejection',
  RECEIVED_REJECTION_DOCUMENT:
    'digital.fino.cyclope.api.events.receiving.ReceivedRejectionDocument',
  RECEIVED_SIGNED_WARRANT_UPLOADED:
    'digital.fino.cyclope.api.events.receiving.ReceivedSignedWarrantUploaded',
  REJECTED_REQUEST:
    'digital.fino.cyclope.api.events.transferring.RejectedRequest',
  REQUEST_FORM_FILLED:
    'digital.fino.cyclope.api.events.receiving.RequestFormFilled',
  REQUEST_WAS_RESET: 'digital.fino.cyclope.api.events.receiving.TicketWasReset',
  // From historically, this state is known as global state without its 'receiving' type
  // REMINDER_SENT                             : 'digital.fino.cyclope.api.events.receiving.ReminderSent',
  REMINDER_SENT_VIA_FAX:
    'digital.fino.cyclope.api.events.receiving.ReminderSentViaFax',
  SENT_REQUEST_TO_TRANSFERRING:
    'digital.fino.cyclope.api.events.receiving.SentRequestToTransferring',
  WARRANT_SHIPMENT_SKIPPED:
    'digital.fino.cyclope.api.events.receiving.WarrantShipmentSkipped',
  SIGNED_WARRANT_TRANSFER_FAILED:
    'digital.fino.cyclope.api.events.receiving.SignedWarrantTransferFailed',
  STANDING_ORDERS_PROCESSED:
    'digital.fino.cyclope.api.events.receiving.StandingOrdersProcessed',
  TRANSACTION_DATA_APPROVED:
    'digital.fino.cyclope.api.events.receiving.TransactionDataApproved',
  TRANSACTION_DATA_RECEIVED:
    'digital.fino.cyclope.api.events.receiving.TransactionDataReceived',
  VERIFIED_FINANCES:
    'digital.fino.cyclope.api.events.receiving.VerifiedFinances',
  WARRANT_SIGNED: 'digital.fino.cyclope.api.events.receiving.WarrantSigned',
  DEPOT_TRANSFER_STARTED: 'DEPOT_TRANSFER_STARTED',
  DEPOT_TRANSFER_CANCELED: 'DEPOT_TRANSFER_CANCELLED',
  DEPOT_TRANSFER_COMPLETED: 'DEPOT_TRANSFER_COMPLETED',
};

// This is a helper to aggregate multiple states into one state
export const AggregatedTicketStates = {
  [TicketStatesReceiving.PAYMENT_PARTNER_INFORMATION_STARTED]:
    'ui.events.finish',
  [TicketStatesReceiving.DOCUMENT_SENDING_STARTED]: 'ui.events.finish',
  [TicketStatesReceiving.DOCUMENT_SENT]: 'ui.events.finish',
  [TicketStatesReceiving.DOCUMENT_SENT_VIA_FAX]: 'ui.events.finish',
  [TicketStatesReceiving.ALL_DOCUMENTS_SENT]: 'ui.events.finish',
  [TicketStatesReceiving.STANDING_ORDERS_PROCESSED]: 'ui.events.finish',
  // For backwards compatibility (the time before we had the status)
  [TicketStatesReceiving.VERIFIED_FINANCES]: 'ui.events.finish',
};

// This is a helper to combine state siblings on the ticket list
export const TicketStatesSiblings = {
  [TicketStatesReceiving.TRANSACTION_DATA_RECEIVED]: [
    TicketStatesReceiving.BALANCE_LIST_DOCUMENT_RECEIVED,
    TicketStatesReceiving.BALANCE_LIST_WITHDRAWN,
  ],
  [TicketStatesTransferring.FINANCES_VERIFIED]: [
    TicketStatesTransferring.TRANSACTION_DATA_SENT,
    TicketStatesTransferring.TRANSACTION_DATA_SENT_VIA_FAX,
  ],
  [TicketStatesReceiving.DOCUMENT_SENT]: [
    TicketStatesReceiving.DOCUMENT_SENT_VIA_FAX,
  ],
  [TicketStatesReceiving.SENT_REQUEST_TO_TRANSFERRING]: [
    TicketStatesGlobal.REMINDER_SENT,
    TicketStatesReceiving.REMINDER_SENT_VIA_FAX,
    TicketStatesReceiving.BALANCE_LIST_WITHDRAWN,
  ],
  [TicketStatesReceiving.VERIFIED_FINANCES]: [
    TicketStatesReceiving.TRANSACTION_DATA_APPROVED,
    TicketStatesReceiving.BALANCE_LIST_DATA_RECEIVED,
  ],
};

export const TicketStates = angular.extend(
  TicketStatesGlobal,
  TicketStatesTransferring,
  TicketStatesReceiving,
);

export const DeadlineStatusList = {
  overdue: 'deadline.overdue',
  today: 'deadline.today',
  tomorrow: 'deadline.tomorrow',
  week: 'deadline.week',
  none: 'deadline.none',
};

export const NoDeadlineStatus = [TicketStatesReceiving.CLOSED_BY_CUSTOMER];

// TODO Find a better way to handle linking as doing this in the ticket controller
export const ExternalLinking = [
  {
    route: 'app.receiving.submitRequest',
    states: [TicketStatesReceiving.WARRANT_SIGNED],
  },
  {
    route: 'app.receiving.confirmRequest',
    states: [TicketStatesReceiving.REQUEST_FORM_FILLED],
  },
  {
    route: 'app.transferring.confirmWarrant',
    states: [TicketStatesTransferring.RECEIVED_OUTGOING_REQUEST],
    condition: (ticket) => {
      // Link to confirmWarrant state when the ticket is missing the `fromIban` value
      return !ticket.fromIban;
    },
  },
];

export const ViewStatus = {
  Pending: 'pending',
  Declined: 'declined',
  Completed: 'completed',
  Custom: 'custom',
};

export const TicketType = {
  Transferring: 'transferring',
  Receiving: 'receiving',
};

export const TicketRequestType = {
  Outgoing: 'outgoing',
  Incoming: 'incoming',
};

export const TicketRequestTypeMap = {
  [TicketRequestType.Outgoing]: TicketType.Transferring,
  [TicketRequestType.Incoming]: TicketType.Receiving,
};

export const TicketTypeMatching = {
  [TicketType.Transferring]: [
    TicketType.Transferring,
    TicketRequestType.Outgoing,
  ],
  [TicketType.Receiving]: [TicketType.Receiving, TicketRequestType.Incoming],
};

export const TicketActions = {
  CHANGE_EMPLOYEE_STATUS: 'app.ticket.actions.changeEmployeeStatus',
};

export const ProductType = {
  DWS: 'DWS',
  KWS: 'KWS',
  KWH: 'KWH',
};
